import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {Video} from "../../interfaces/video";

@Component({
  selector: 'brt-embed-video-overlay',
  templateUrl: './embed-video-overlay.component.html',
  styleUrls: ['./embed-video-overlay.component.scss']
})
export class EmbedVideoOverlayComponent implements Overlayable{
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Input('iframe-str') iframe!: Video;
}
